import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { EffectsMode } from '../lib/devicePerf';

// Settings that describe this physical screen rather than the account, so they are never
// synced to other screens or saved in layouts (e.g. Lite mode for a Fire TV stick).

interface DeviceStore {
  effects: EffectsMode;
  setEffects: (effects: EffectsMode) => void;
}

export const useDevice = create<DeviceStore>()(
  persist(
    (set) => ({
      effects: 'auto',
      setEffects: (effects) => set({ effects }),
    }),
    { name: 'kcl-canvas-device', version: 1, partialize: (s) => ({ effects: s.effects }) },
  ),
);
